// MessageThumbnail.jsx
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { MediaAssetFormat } from '../resource/getMediaAsset.js';
import getPublicSrcSet from '../resource/getPublicSrcSet.js';

export const MessageThumbnail = ({
  username,
  captionText,
  thumbnail,
  objectFit,
}) => {
  const altText = username && captionText ? `${username} : ${captionText}` : '';

  const [avifSrcSet, webpSrcSet, jpgSrcSet] = useMemo(
    () =>
      [MediaAssetFormat.AVIF, MediaAssetFormat.WEBP, MediaAssetFormat.JPG].map(
        format => getPublicSrcSet({ href: thumbnail, size: 256, format })
      ),
    [thumbnail]
  );

  return (
    <picture>
      <source {...avifSrcSet} type="image/avif" />
      <source {...webpSrcSet} type="image/webp" />
      <Image {...jpgSrcSet} alt={altText} objectFit={objectFit} />
    </picture>
  );
};

MessageThumbnail.propTypes = {
  username: PropTypes.string,
  captionText: PropTypes.string,
  thumbnail: PropTypes.string,
  objectFit: PropTypes.string,
};

MessageThumbnail.defaultProps = {
  username: '',
  captionText: '',
  thumbnail: '',
  objectFit: 'contain',
};

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${({ objectFit }) => objectFit};
`;

export default MessageThumbnail;
